import { LucideIcon } from 'components/LucideIcon'
import { DropdownMenuContent } from 'designSystem/components/DropdownMenu'
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from 'designSystem/components/Sidebar'
import { StyledDropdownMenuTrigger } from 'features/navbar/NavbarDropdown'
import React from 'react'

import { ConfigSettingsBase } from './ConfigSettingsBase'
import {
  ConfigSettingsSidebarMenuItems,
  type WorkspaceSettingsNavigateHandler,
} from './ConfigSettingsSidebarMenuItems'
import { type ConfigSettingsProps } from './useConfigSettingsState'

export const ConfigSettingsSidebar: React.FC<
  ConfigSettingsProps & {
    onWorkspaceNavigate: WorkspaceSettingsNavigateHandler
  }
> = ({ orgID, siteID, onWorkspaceNavigate }) => (
  <ConfigSettingsBase
    orgID={orgID}
    renderTrigger={(state) => (
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={state.isOpen} variant='embedded'>
          <StyledDropdownMenuTrigger
            type='button'
            aria-label='Open config settings menu'>
            <LucideIcon name='Settings' />
            <span>Settings</span>
          </StyledDropdownMenuTrigger>
        </SidebarMenuButton>
      </SidebarMenuItem>
    )}
    renderContent={(state) => (
      <DropdownMenuContent side='right' sideOffset={12} align='end' width='md'>
        <ConfigSettingsSidebarMenuItems
          orgID={orgID}
          siteID={siteID}
          state={state}
          onWorkspaceNavigate={onWorkspaceNavigate}
        />
      </DropdownMenuContent>
    )}
  />
)
